export const formatDateOptions = (timeZone: string, options: Record<string, unknown>, inLocalTimeLD?: boolean) => {
  return inLocalTimeLD ? options : { ...options, timeZone };
};
